import axiosClient from '../axiosClient';

export const getAdminNotifications = (params) =>
  axiosClient.get('/notifications', { params });

export const markAdminNotificationRead = (id) =>
  axiosClient.put(`/notifications/${id}/read`);

export const markAllAdminNotificationsRead = () =>
  axiosClient.put('/notifications/read-all');
